/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ThankYouImport } from './routes/thankYou'
import { Route as ServerErrorImport } from './routes/serverError'
import { Route as RtkImport } from './routes/rtk'
import { Route as ProgramsImport } from './routes/programs'
import { Route as PolicyImport } from './routes/policy'
import { Route as PaymentProcessingImport } from './routes/payment-processing'
import { Route as NotfoundImport } from './routes/notfound'
import { Route as MaintenanceImport } from './routes/maintenance'
import { Route as FaqsImport } from './routes/faqs'
import { Route as DonorProfileImport } from './routes/donor-profile'
import { Route as DonateNowImport } from './routes/donate-now'
import { Route as ContactImport } from './routes/contact'
import { Route as CommunityChallengeImport } from './routes/community-challenge'
import { Route as CohImport } from './routes/coh'
import { Route as CircleCreationImport } from './routes/circle-creation'
import { Route as AboutUsImport } from './routes/about-us'
import { Route as IndexImport } from './routes/index'
import { Route as ProgramProgramIdImport } from './routes/program.$programId'
import { Route as PaymentFlowProgramIdImport } from './routes/paymentFlow.$programId'
import { Route as GratitudeProgramIdImport } from './routes/gratitude.$programId'
import { Route as CircleCircleIdImport } from './routes/circle.$circleId'
import { Route as ChallengeChallengeIdImport } from './routes/challenge.$challengeId'
import { Route as ChallengePaymentChallengeIdImport } from './routes/challenge-payment.$challengeId'
import { Route as ChallengeCheckoutChallengeIdImport } from './routes/challenge-checkout.$challengeId'

// Create/Update Routes

const ThankYouRoute = ThankYouImport.update({
  path: '/thankYou',
  getParentRoute: () => rootRoute,
} as any)

const ServerErrorRoute = ServerErrorImport.update({
  path: '/serverError',
  getParentRoute: () => rootRoute,
} as any)

const RtkRoute = RtkImport.update({
  path: '/rtk',
  getParentRoute: () => rootRoute,
} as any)

const ProgramsRoute = ProgramsImport.update({
  path: '/programs',
  getParentRoute: () => rootRoute,
} as any)

const PolicyRoute = PolicyImport.update({
  path: '/policy',
  getParentRoute: () => rootRoute,
} as any)

const PaymentProcessingRoute = PaymentProcessingImport.update({
  path: '/payment-processing',
  getParentRoute: () => rootRoute,
} as any)

const NotfoundRoute = NotfoundImport.update({
  path: '/notfound',
  getParentRoute: () => rootRoute,
} as any)

const MaintenanceRoute = MaintenanceImport.update({
  path: '/maintenance',
  getParentRoute: () => rootRoute,
} as any)

const FaqsRoute = FaqsImport.update({
  path: '/faqs',
  getParentRoute: () => rootRoute,
} as any)

const DonorProfileRoute = DonorProfileImport.update({
  path: '/donor-profile',
  getParentRoute: () => rootRoute,
} as any)

const DonateNowRoute = DonateNowImport.update({
  path: '/donate-now',
  getParentRoute: () => rootRoute,
} as any)

const ContactRoute = ContactImport.update({
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any)

const CommunityChallengeRoute = CommunityChallengeImport.update({
  path: '/community-challenge',
  getParentRoute: () => rootRoute,
} as any)

const CohRoute = CohImport.update({
  path: '/coh',
  getParentRoute: () => rootRoute,
} as any)

const CircleCreationRoute = CircleCreationImport.update({
  path: '/circle-creation',
  getParentRoute: () => rootRoute,
} as any)

const AboutUsRoute = AboutUsImport.update({
  path: '/about-us',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ProgramProgramIdRoute = ProgramProgramIdImport.update({
  path: '/program/$programId',
  getParentRoute: () => rootRoute,
} as any)

const PaymentFlowProgramIdRoute = PaymentFlowProgramIdImport.update({
  path: '/paymentFlow/$programId',
  getParentRoute: () => rootRoute,
} as any)

const GratitudeProgramIdRoute = GratitudeProgramIdImport.update({
  path: '/gratitude/$programId',
  getParentRoute: () => rootRoute,
} as any)

const CircleCircleIdRoute = CircleCircleIdImport.update({
  path: '/circle/$circleId',
  getParentRoute: () => rootRoute,
} as any)

const ChallengeChallengeIdRoute = ChallengeChallengeIdImport.update({
  path: '/challenge/$challengeId',
  getParentRoute: () => rootRoute,
} as any)

const ChallengePaymentChallengeIdRoute =
  ChallengePaymentChallengeIdImport.update({
    path: '/challenge-payment/$challengeId',
    getParentRoute: () => rootRoute,
  } as any)

const ChallengeCheckoutChallengeIdRoute =
  ChallengeCheckoutChallengeIdImport.update({
    path: '/challenge-checkout/$challengeId',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsImport
      parentRoute: typeof rootRoute
    }
    '/circle-creation': {
      id: '/circle-creation'
      path: '/circle-creation'
      fullPath: '/circle-creation'
      preLoaderRoute: typeof CircleCreationImport
      parentRoute: typeof rootRoute
    }
    '/coh': {
      id: '/coh'
      path: '/coh'
      fullPath: '/coh'
      preLoaderRoute: typeof CohImport
      parentRoute: typeof rootRoute
    }
    '/community-challenge': {
      id: '/community-challenge'
      path: '/community-challenge'
      fullPath: '/community-challenge'
      preLoaderRoute: typeof CommunityChallengeImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactImport
      parentRoute: typeof rootRoute
    }
    '/donate-now': {
      id: '/donate-now'
      path: '/donate-now'
      fullPath: '/donate-now'
      preLoaderRoute: typeof DonateNowImport
      parentRoute: typeof rootRoute
    }
    '/donor-profile': {
      id: '/donor-profile'
      path: '/donor-profile'
      fullPath: '/donor-profile'
      preLoaderRoute: typeof DonorProfileImport
      parentRoute: typeof rootRoute
    }
    '/faqs': {
      id: '/faqs'
      path: '/faqs'
      fullPath: '/faqs'
      preLoaderRoute: typeof FaqsImport
      parentRoute: typeof rootRoute
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceImport
      parentRoute: typeof rootRoute
    }
    '/notfound': {
      id: '/notfound'
      path: '/notfound'
      fullPath: '/notfound'
      preLoaderRoute: typeof NotfoundImport
      parentRoute: typeof rootRoute
    }
    '/payment-processing': {
      id: '/payment-processing'
      path: '/payment-processing'
      fullPath: '/payment-processing'
      preLoaderRoute: typeof PaymentProcessingImport
      parentRoute: typeof rootRoute
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyImport
      parentRoute: typeof rootRoute
    }
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsImport
      parentRoute: typeof rootRoute
    }
    '/rtk': {
      id: '/rtk'
      path: '/rtk'
      fullPath: '/rtk'
      preLoaderRoute: typeof RtkImport
      parentRoute: typeof rootRoute
    }
    '/serverError': {
      id: '/serverError'
      path: '/serverError'
      fullPath: '/serverError'
      preLoaderRoute: typeof ServerErrorImport
      parentRoute: typeof rootRoute
    }
    '/thankYou': {
      id: '/thankYou'
      path: '/thankYou'
      fullPath: '/thankYou'
      preLoaderRoute: typeof ThankYouImport
      parentRoute: typeof rootRoute
    }
    '/challenge-checkout/$challengeId': {
      id: '/challenge-checkout/$challengeId'
      path: '/challenge-checkout/$challengeId'
      fullPath: '/challenge-checkout/$challengeId'
      preLoaderRoute: typeof ChallengeCheckoutChallengeIdImport
      parentRoute: typeof rootRoute
    }
    '/challenge-payment/$challengeId': {
      id: '/challenge-payment/$challengeId'
      path: '/challenge-payment/$challengeId'
      fullPath: '/challenge-payment/$challengeId'
      preLoaderRoute: typeof ChallengePaymentChallengeIdImport
      parentRoute: typeof rootRoute
    }
    '/challenge/$challengeId': {
      id: '/challenge/$challengeId'
      path: '/challenge/$challengeId'
      fullPath: '/challenge/$challengeId'
      preLoaderRoute: typeof ChallengeChallengeIdImport
      parentRoute: typeof rootRoute
    }
    '/circle/$circleId': {
      id: '/circle/$circleId'
      path: '/circle/$circleId'
      fullPath: '/circle/$circleId'
      preLoaderRoute: typeof CircleCircleIdImport
      parentRoute: typeof rootRoute
    }
    '/gratitude/$programId': {
      id: '/gratitude/$programId'
      path: '/gratitude/$programId'
      fullPath: '/gratitude/$programId'
      preLoaderRoute: typeof GratitudeProgramIdImport
      parentRoute: typeof rootRoute
    }
    '/paymentFlow/$programId': {
      id: '/paymentFlow/$programId'
      path: '/paymentFlow/$programId'
      fullPath: '/paymentFlow/$programId'
      preLoaderRoute: typeof PaymentFlowProgramIdImport
      parentRoute: typeof rootRoute
    }
    '/program/$programId': {
      id: '/program/$programId'
      path: '/program/$programId'
      fullPath: '/program/$programId'
      preLoaderRoute: typeof ProgramProgramIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AboutUsRoute,
  CircleCreationRoute,
  CohRoute,
  CommunityChallengeRoute,
  ContactRoute,
  DonateNowRoute,
  DonorProfileRoute,
  FaqsRoute,
  MaintenanceRoute,
  NotfoundRoute,
  PaymentProcessingRoute,
  PolicyRoute,
  ProgramsRoute,
  RtkRoute,
  ServerErrorRoute,
  ThankYouRoute,
  ChallengeCheckoutChallengeIdRoute,
  ChallengePaymentChallengeIdRoute,
  ChallengeChallengeIdRoute,
  CircleCircleIdRoute,
  GratitudeProgramIdRoute,
  PaymentFlowProgramIdRoute,
  ProgramProgramIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about-us",
        "/circle-creation",
        "/coh",
        "/community-challenge",
        "/contact",
        "/donate-now",
        "/donor-profile",
        "/faqs",
        "/maintenance",
        "/notfound",
        "/payment-processing",
        "/policy",
        "/programs",
        "/rtk",
        "/serverError",
        "/thankYou",
        "/challenge-checkout/$challengeId",
        "/challenge-payment/$challengeId",
        "/challenge/$challengeId",
        "/circle/$circleId",
        "/gratitude/$programId",
        "/paymentFlow/$programId",
        "/program/$programId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about-us": {
      "filePath": "about-us.tsx"
    },
    "/circle-creation": {
      "filePath": "circle-creation.tsx"
    },
    "/coh": {
      "filePath": "coh.tsx"
    },
    "/community-challenge": {
      "filePath": "community-challenge.tsx"
    },
    "/contact": {
      "filePath": "contact.tsx"
    },
    "/donate-now": {
      "filePath": "donate-now.tsx"
    },
    "/donor-profile": {
      "filePath": "donor-profile.tsx"
    },
    "/faqs": {
      "filePath": "faqs.tsx"
    },
    "/maintenance": {
      "filePath": "maintenance.tsx"
    },
    "/notfound": {
      "filePath": "notfound.tsx"
    },
    "/payment-processing": {
      "filePath": "payment-processing.tsx"
    },
    "/policy": {
      "filePath": "policy.tsx"
    },
    "/programs": {
      "filePath": "programs.tsx"
    },
    "/rtk": {
      "filePath": "rtk.tsx"
    },
    "/serverError": {
      "filePath": "serverError.tsx"
    },
    "/thankYou": {
      "filePath": "thankYou.tsx"
    },
    "/challenge-checkout/$challengeId": {
      "filePath": "challenge-checkout.$challengeId.tsx"
    },
    "/challenge-payment/$challengeId": {
      "filePath": "challenge-payment.$challengeId.tsx"
    },
    "/challenge/$challengeId": {
      "filePath": "challenge.$challengeId.tsx"
    },
    "/circle/$circleId": {
      "filePath": "circle.$circleId.tsx"
    },
    "/gratitude/$programId": {
      "filePath": "gratitude.$programId.tsx"
    },
    "/paymentFlow/$programId": {
      "filePath": "paymentFlow.$programId.tsx"
    },
    "/program/$programId": {
      "filePath": "program.$programId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
